import React from 'react'
import MarkerWithLabel from './MarkerWithLabel'
import helpers from '../helpers'

const LiveTracking = ({ drivers, data }) => {
  if (data && !data.driverUid) return null

  const { driverUid, merchantLocation, deliveryLocation, merchantName } = data
  const driver = drivers[driverUid]

  return (
    <React.Fragment>
      <MarkerWithLabel
        location={driver.location}
        icon={helpers.getIconByStatus(driver.status)}
        label={`${driver.family_name} ${driver.first_name}`}
        labelColor={helpers.getLabelColor(driver.status)}
      />

      <MarkerWithLabel
        location={merchantLocation}
        icon={helpers.icons.restaurant}
        label={merchantName}
        labelColor={helpers.getLabelColor()}
      />

      <MarkerWithLabel
        location={deliveryLocation}
        icon={helpers.icons.userHome}
        label='User Address'
        labelColor={helpers.getLabelColor()}
      />
    </React.Fragment>
  )
}

export default LiveTracking



// WEBPACK FOOTER //
// ./src/containers/mapView/components/LiveTracking.js